export default function initScrollyTelling() {

  // Disable scroll restoration
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }

  // Scroll to the top
  window.scrollTo(0, 0);

  // Scroll to the top before page load to prevent bugs
  window.addEventListener("beforeunload", function () {
    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }
    window.scrollTo(0, 0);
  });

  gsap.registerPlugin(ScrollTrigger);

  const canvas = document.querySelector('#ScrollytellingLogo canvas');

  if (canvas) {
    const context = canvas.getContext('2d');

    // Canvas config
    canvas.width = 1000;
    canvas.height = 1000;

    let isMobile = window.innerWidth <= 768; // Check if the screen width is 768px or less

    // Refresh on resize with debounce function
    window.addEventListener("resize", debounce(function () {
      isMobile = window.innerWidth <= 768; // Check if the screen width is 768px or less

      canvas.width = 1000;
      canvas.height = 1000;
      ScrollTrigger.refresh();
    }), 300);

    function debounce(func, wait) {
      let timeout;
      return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }

    // Configuration

    const frameDuration = isMobile ? 20 : 10; // Frames per pause
    const pauses = [0, 35, 69, 104, 139]; // Paused image indices
    const imageCount = 139; // Total number of images
    const frameCount = pauses.length * frameDuration + (pauses.length - 1) * (imageCount / pauses.length); // Dynamically calculate total frames
    let imageIndex = 1;
    const images = [];
    const sequence = {
      frame: 0
    };

    let currentFrame = index => (
      `/images/scrollytelling/equans_scrollytelling_${(index + 1).toString()}.webp`
    );


    // Preload images
    let imagesLoaded = 0;
    for (let i = 0; i < imageCount; i++) {
      let img = new Image();
      img.src = currentFrame(i);
      images.push(img);
    }

    // Create Sequence with all the frames
    gsap.to(sequence, {
      frame: frameCount - 1,
      snap: {
        snapTo: "labels", // Snap to the nearest label
        duration: 0.25, // Smooth snap duration
        ease: "power1.inOut" // Easing for the snap
      },
      scrollTrigger: {
        start: `50% top`,
        end: `400% top`, // Adjust scroll distance
        trigger: "#ScrollytellingLogo",
        scrub: isMobile ? 0 : 0,
      },
      onUpdate: render
    });

    // When first image loaded, execute render function
    images[0].onload = render;

    // Transition between parts and add active to current part
    function setActivePart(activePartId) {
      const parts = ["#part1", "#part2", "#part3", "#part4"];
      parts.forEach(part => {
        const element = document.querySelector(part);
        if (element) {
          if (part === activePartId) {
            element.classList.add("active");
          } else {
            element.classList.remove("active");
          }
        }
      });

      gsap.to(".Scrollytelling__content_section:not("+activePartId+")", { opacity: 0, duration: 0.3 });
      gsap.to(activePartId, { opacity: 1, duration: 0.3 });
    }

    function render() {
      // Don't do anything if same frame or same index
      if ((currentFrame === sequence.frame || imageIndex === getImageIndex(sequence.frame))) {
        return;
      }

      // Set new current frame
      currentFrame = sequence.frame;

      // Map sequence.frame to an image index
      imageIndex = getImageIndex(sequence.frame);
      // console.log(`Frame: ${sequence.frame}, Image Index: ${imageIndex}`);

      // Scale the image on the canvas
      if (imageIndex >= 0 && imageIndex < imageCount) {
        scaleImage(images[imageIndex], context);
      }

      // Set background image on if completed
      if (imageIndex >= 139) {
        $(".Scrollytelling__canvas__ratio").css("background-image", "url("+images[images.length - 1]["currentSrc"]+")");
      } else {
        $(".Scrollytelling__canvas__ratio").css("background-image", "url("+images[0]["currentSrc"]+")");
      }

      // Check which phase the imageIndex belongs to and animate accordingly
      if (imageIndex < 25) {
        setActivePart("#part1");
      } else if (imageIndex >= 25 && imageIndex < 59) {
        setActivePart("#part2");
      } else if (imageIndex >= 59 && imageIndex < 94) {
        setActivePart("#part3");
      } else if (imageIndex >= 94 && imageIndex < 129) {
        setActivePart("#part4");
      } else if (imageIndex >= 129) {
        setActivePart("#part5");
      }
    }

    // Map frames to image indices with pauses and incremental transitions
    function getImageIndex(frame) {
      if (frame === 0) return 0; // Ensure Frame 0 starts at Image 0

      const pauseIncreaseFactor = 1.5; // Increses the length of pause frames
      const totalPhases = pauses.length;
      const totalTransitionFrames = frameCount - totalPhases * frameDuration; // Frames spent transitioning
      const framesPerTransition = totalTransitionFrames / (totalPhases - 1); // Frames per transition between pauses

      let phaseIndex = Math.floor(frame / (frameDuration + framesPerTransition));
      if (phaseIndex >= totalPhases) phaseIndex = totalPhases - 1;

      const phaseStartFrame = phaseIndex * (frameDuration + framesPerTransition);
      const phasePauseEndFrame = phaseStartFrame + (frameDuration * pauseIncreaseFactor);

      if (frame <= phasePauseEndFrame) {
        return pauses[phaseIndex]; // Inside pause range, return the exact pause frame
      } else {
        // Transition smoothly between pauses, ensuring increment by 1
        const transitionStartFrame = phasePauseEndFrame;
        const transitionEndFrame = phaseStartFrame + frameDuration + framesPerTransition;
        const progress = (frame - transitionStartFrame) / (transitionEndFrame - transitionStartFrame);

        const startIndex = pauses[phaseIndex];
        const endIndex = pauses[phaseIndex + 1];

        // Ensure imageIndex increments by 1, not jumps
        const newIndex = startIndex + Math.round(progress * (endIndex - startIndex));

        return Math.min(newIndex, imageCount - 1); // Ensure it never goes beyond max images
      }
    }


    function scaleImage(img, ctx) {
      var canvas = ctx.canvas;
      var hRatio = canvas.width / img.width;
      var vRatio = canvas.height / img.height;
      var ratio = Math.max(hRatio, vRatio);
      var centerShift_x = (canvas.width - img.width * ratio) / 2;
      var centerShift_y = (canvas.height - img.height * ratio) / 2;
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(
        img,
        0,
        0,
        img.width,
        img.height,
        centerShift_x,
        centerShift_y,
        img.width * ratio,
        img.height * ratio
      );
    }

    // Pin the section during scrolling
    ScrollTrigger.create({
      trigger: "#ScrollytellingLogo",
      pin: true,
      scrub: true,
      start: `top top`,
      end: `450% 100%`,
      onComplete: () => {
        $(".Scrollytelling__canvas__ratio").addClass("done");
      },
      onEnterBack: () => {
        $(".Scrollytelling__canvas__ratio").removeClass("done");
      }
    });
  }
}